import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormReferenceTreeSelectAsync,
  title: 'Reference Tree Select (Async)',
  category: ComponentCategory.FormControls,
};
